import React, { useState } from "react";
import ViewIcon from "../../utils/assets/view.svg";
import HideIcon from "../../utils/assets/hide.svg";
import { Link } from "react-router-dom";
import {signIn} from '../../actions/auth'
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';

const SignIn = () => {
  const [userData, setUserData] = useState({
    email: "",
    password: ""
  })
  console.log(userData);
  const [passwordIcon, setPasswordIcon] = useState("password");
  const [error, setError] = useState("")

  const navigate = useNavigate();

   function handleForm (e) {
    e.preventDefault();
    const formData = {
      email: userData.email,
      password: userData.password
    }
    if(userData.email && userData.password){
         signIn(formData, navigate, setError).then((res) => {
          if(res?.data?.success == true){
            toast.success("You are Logged-in")
            const userData = res.data.data
            localStorage.setItem("userDetails", JSON.stringify(userData))
          }else{
            toast.error("Invalid Credentials")
          }
          // setError(res);
         })
    }else{
        toast("please enter email & password")
    }
}

  return (
    <>
    <div className="hide-on-sm bg-light min-vh-100">
      <div className="container">
        <div className="row h-vh d-flex justify-content-center align-items-center">
          <div className="col-lg-6 col-md-8 col-sm-12 col-xs-12">
            <form onSubmit={handleForm}
              style={{ borderRadius: "20px" }}
              className="card bg-white shadow d-flex justify-content-center text-start align-items-start p-5"
            >
              <h3 className="text-black txt-head">RMA Updates</h3>
              <p className="txt-secondary txt-p text-wrap">
                Welcome to RMA Updates, where your devices come back
                to life. Sign in to get started.
              </p>
              <div className="error-text w-100">
                <p className="text-center error-text text-danger">{error}</p>
              </div>
              <div className="w-100 mt-2">
                <label htmlFor="" className="form-label text-black">
                  Email
                </label>
                <input type="email" required value={userData.email} onChange={(e) => {
                  setUserData({...userData, email: e.target.value})
                }} className="form-control" />
              </div>
              <div className="w-100 mt-2">
                <label htmlFor="" className="form-label text-black">
                  password
                </label>
                <div className="input-group">
                  <input type={passwordIcon} required value={userData.password} onChange={(e) => {
                    setUserData({...userData, password: e.target.value})
                  }} minLength={8} className="form-control" />
                  {passwordIcon === "text" ? (
                    <span
                      onClick={() => setPasswordIcon("password")}
                      className="input-group-text"
                      id="basic-addon1"
                    >
                      {" "}
                      <img width={20} src={HideIcon} alt="password" />
                    </span>
                  ) : (
                    <span
                      onClick={() => setPasswordIcon("text")}
                      className="input-group-text"
                      id="basic-addon1"
                    >
                      {" "}
                      <img width={20} src={ViewIcon} alt="password" />
                    </span>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-center w-100">
                <button type="submit" className="btn bg-black text-white mt-3 w-50">Submit</button>
              </div>
              <div className=" w-100 justify-content-center align-items-center mt-3 text-center">
                <span className="my-1 txt-p txt-secondary">Are you a new customer? <Link to="/sign-up" className="txt-secondary">Sign up</Link> </span>
                <br />
                <span className="my-1 txt-p txt-secondary">Forgot your password? <Link to="/forgot-password" className="txt-secondary">Click here</Link> to reset it. </span>
              
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div className="hide-on-lg bg-light">
    <div className="container">
        <div className="row h-vh d-flex justify-content-center align-items-center">
          <div className="col-lg-6 col-md-8 col-sm-12 col-xs-12">
            <form onSubmit={handleForm}
              className="justify-content-center text-start align-items-start p-4"
            >
              <h3 className="text-black txt-head">Mac Repair Specialist</h3>
              <p className="txt-secondary txt-p text-wrap">
                Welcome to Mac Repair Specialist, <br /> Sign in to get started.
              </p>
              <div className="error-text w-100">
                <p className="text-center error-text text-danger mb-0">{error}</p>
              </div>
              <div className="w-100 mt-2">
                <label htmlFor="" className="form-label text-black">
                  Email
                </label>
                <input type="email" value={userData.email} onChange={(e) => {
                  setUserData({...userData, email: e.target.value})
                }} required className="form-control" />
              </div>
              <div className="w-100 mt-2">
                <label htmlFor="" className="form-label text-black">
                  password
                </label>
                <div className="input-group">
                  <input type={passwordIcon} required value={userData.password} onChange={(e) => {
                    setUserData({...userData, password: e.target.value})
                  }}  minLength={8} className="form-control" />
                  {passwordIcon === "text" ? (
                    <span
                      onClick={() => setPasswordIcon("password")}
                      className="input-group-text"
                      id="basic-addon1"
                    >
                      {" "}
                      <img width={20} src={HideIcon} alt="password" />
                    </span>
                  ) : (
                    <span
                      onClick={() => setPasswordIcon("text")}
                      className="input-group-text"
                      id="basic-addon1"
                    >
                      {" "}
                      <img width={20} src={ViewIcon} alt="password" />
                    </span>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-center w-100">
                <button type="submit" className="btn bg-black text-white mt-5 w-100 w-lg-50">Submit</button>
              </div>
              <div className="w-100 justify-content-center align-items-center mt-3 text-center">
                <span className="my-1 txt-p txt-secondary">Are you a new customer? <Link to="/sign-up" className="txt-secondary">Sign up</Link> </span>
                <br />
                <span className="my-1 txt-p txt-secondary">Forgot your password? <Link to="/forgot-password" className="txt-secondary">Click here</Link> to reset it. </span>
              
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default SignIn;
